module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "hrms31e-detail"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.indexSelected.codempid) + " - " + _vm._s(_vm.indexSelected.desc_codempid))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.indexSelected.numseq))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.codeval) + " - " + _vm._s(_vm.descCodeval))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [(_vm.detail.tab2.table1.rows.length > 0) ? _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRPM31EP1']['50']) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "details2"
    }
  }, [_c('div', {
    staticClass: "panel-body clear-padding"
  }, [_c('div', {
    staticClass: "detail detail-responsive panel-detail-filter clearfix"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-5 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP2']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail.tab2.detail.codform) + " - " + _vm._s(_vm.detail.tab2.detail.desc_codform))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-5 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP2']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab2.detail.commboss),
      expression: "detail.tab2.detail.commboss"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:600'),
      expression: "'max:600'"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "600",
      "data-vv-name": "commboss",
      "has-error": _vm.errors.has('commboss')
    },
    domProps: {
      "value": (_vm.detail.tab2.detail.commboss)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab2.detail, "commboss", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('commboss')),
      expression: "errors.has('commboss')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('commboss')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(600)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "col-md-12 clear-padding"
  }, [_c('div', {
    staticClass: "evaluation-wrapper"
  }, [_vm._l((_vm.detail.tab2.table1.rows), function(dataGroup) {
    return [_c('group', {
      attrs: {
        "labels": _vm.labels,
        "dataGroup": dataGroup,
        "choices": _vm.detail.tab2.table2.rows,
        "changeChoice": _vm.changeChoice,
        "name": "detail"
      }
    })]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 clear-padding"
  }, [_c('div', {
    staticClass: "evaluation-sum"
  }, [_vm._v("\n                    " + _vm._s(_vm.labels['HRPM31EP2']['100']) + " " + _vm._s(_vm.scorepr) + "/" + _vm._s(_vm.calTotalScore(_vm.detail.tab2.table1.rows)) + "\n                  ")])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details3"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRPM31EP1']['60']) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "details3"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive "
  }, [_c('detail-search', {
    attrs: {
      "receivedHrms31eDetailSearch": _vm.receivedHrms31eDetailSearch,
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "nowLang": _vm.nowLang,
      "setSaveButtonDisp": _vm.setSaveButtonDisp,
      "codempid": _vm.indexSelected.codempid,
      "dtest": _vm.detail.tab1.dteempmt,
      "dteen": _vm.detail.tab1.dteduepr
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-block-float detail-block-left"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP3']['40']))]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.tab3Table1,
      "data": _vm.detail.tab3.table1,
      "searchDisp": false,
      "tablePageDisp": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-block-float detail-block-right"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP3']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRPM31EP3']['110']))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRPM31EP3']['120']))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRPM31EP3']['130']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-xs-6 col-md-3 "
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP3']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color align-center"
  }, [_vm._v(_vm._s(_vm.detail.tab3.detail.qtytlate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color align-center"
  }, [_vm._v(_vm._s(_vm.detail.tab3.detail.qtylate))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-xs-6 col-md-3 "
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP3']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color align-center"
  }, [_vm._v(_vm._s(_vm.detail.tab3.detail.qtytearly))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color align-center"
  }, [_vm._v(_vm._s(_vm.detail.tab3.detail.qtyearly))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-xs-6 col-md-3 "
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP3']['160']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color align-center"
  }, [_vm._v(_vm._s(_vm.detail.tab3.detail.qtytabs))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color align-center"
  }, [_vm._v(_vm._s(_vm.detail.tab3.detail.qtyabsent))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP3']['170']))]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.tab3Table2,
      "data": _vm.detail.tab3.table2,
      "searchDisp": false,
      "tablePageDisp": false
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRPM31EP1']['40']) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "details1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_typproba))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "input-group margin-b-0",
    staticStyle: {
      "margin": "0px 0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.qtyasg),
      expression: "detail.tab1.qtyasg"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.detail.tab1.qtyasg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "qtyasg", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['90']))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "input-group margin-b-0",
    staticStyle: {
      "margin": "0px 0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.qtyapp),
      expression: "detail.tab1.qtyapp"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.detail.tab1.qtyapp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "qtyapp", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['110']))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dteempmt)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dteduepr)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "dteeval",
      "has-error": _vm.errors.has('dteeval')
    },
    model: {
      value: (_vm.detail.tab1.dteeval),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "dteeval", $$v)
      },
      expression: "detail.tab1.dteeval"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dteeval')),
      expression: "errors.has('dteeval')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dteeval')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('hrms-num-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:6'),
      expression: "'required|max:6'"
    }],
    attrs: {
      "numLength": 3,
      "data-vv-value-path": "inputDate",
      "maxlength": "6",
      "name": "scorepr",
      "data-vv-name": "scorepr",
      "has-error": _vm.errors.has('scorepr')
    },
    model: {
      value: (_vm.detail.tab1.scorepr),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "scorepr", $$v)
      },
      expression: "detail.tab1.scorepr"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('scorepr')),
      expression: "errors.has('scorepr')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('scorepr')))])], 1), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['160']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('hrms-dropdown', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.dropdowns.codrespr[_vm.nowLang],
      "data-vv-value-path": "inputDate",
      "name": "codrespr",
      "has-error": _vm.errors.has('codrespr')
    },
    model: {
      value: (_vm.detail.tab1.codrespr),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "codrespr", $$v)
      },
      expression: "detail.tab1.codrespr"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codrespr')),
      expression: "errors.has('codrespr')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codrespr')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('hrms-num-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ((_vm.detail.tab1.codrespr === 'E' ? 'required' : '')),
      expression: "(detail.tab1.codrespr === 'E' ? 'required' : '')"
    }],
    attrs: {
      "decimal": 0,
      "numLength": 10,
      "name": "qtyexpand",
      "data-vv-scope": "ruleCodrespr",
      "data-vv-value-path": "inputDate",
      "has-error": _vm.errors.has('ruleCodrespr.qtyexpand')
    },
    model: {
      value: (_vm.detail.tab1.qtyexpand),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "qtyexpand", $$v)
      },
      expression: "detail.tab1.qtyexpand"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ruleCodrespr.qtyexpand')),
      expression: "errors.has('ruleCodrespr.qtyexpand')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('ruleCodrespr.qtyexpand')))])], 1), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['190']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('hrms-dropdown', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validateCodexemp),
      expression: "validateCodexemp"
    }],
    attrs: {
      "options": _vm.dropdowns.codexemp[_vm.nowLang],
      "data-vv-value-path": "inputDate",
      "name": "codexemp",
      "has-error": _vm.errors.has('codexemp')
    },
    model: {
      value: (_vm.detail.tab1.codexemp),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "codexemp", $$v)
      },
      expression: "detail.tab1.codexemp"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codexemp')),
      expression: "errors.has('codexemp')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codexemp')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['180']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.desnote),
      expression: "detail.tab1.desnote"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:60'),
      expression: "'max:60'"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "60",
      "data-vv-name": "desnote",
      "has-error": _vm.errors.has('desnote')
    },
    domProps: {
      "value": (_vm.detail.tab1.desnote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "desnote", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('desnote')),
      expression: "errors.has('desnote')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('desnote')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(60)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['200']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.flgappr),
      expression: "detail.tab1.flgappr"
    }],
    attrs: {
      "type": "radio",
      "value": "P"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.tab1.flgappr, "P")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail.tab1, "flgappr", "P")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['210']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.flgappr),
      expression: "detail.tab1.flgappr"
    }],
    attrs: {
      "type": "radio",
      "value": "C"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.tab1.flgappr, "C")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail.tab1, "flgappr", "C")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRPM31EP1']['220']))])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-color-skin margin-b-10",
    class: {
      'pull-right': _vm.pcDisp
    },
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#hrms31e-popup"
    },
    on: {
      "click": function($event) {
        _vm.togglePopupDetail()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" " + _vm._s(_vm.labels['HRPM31EP1']['230']))]), _vm._v(" "), _c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.callBack()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))]), _vm._v(" "), (_vm.flgDispSave) ? _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveParams()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))]) : _vm._e(), _vm._v(" "), (_vm.flgDispSave) ? _c('button', {
    staticClass: "btn bg-red-pink",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.callDelete()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  }), _vm._v(_vm._s(_vm.labelsButton['delete']))]) : _vm._e(), _vm._v(" "), (_vm.btnMailDisp && _vm.flgDispSave) ? _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.callSendMail()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" " + _vm._s(_vm.labelsButton['sendmail']))]) : _c('button', {
    staticClass: "btn bg-color-skin-disable",
    attrs: {
      "type": "button",
      "disabled": !_vm.btnMailDisp
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" " + _vm._s(_vm.labelsButton['sendmail']))])])]), _vm._v(" "), _c('popup', {
    attrs: {
      "labels": _vm.labels,
      "nowLang": _vm.nowLang,
      "popupDetail": _vm.popupDetail,
      "receivedHrms31eDetailPopup": _vm.receivedHrms31eDetailPopup
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9fff1380!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms31e/detail.vue
// module id = 3942
// module chunks = 1